import { FormElement } from './form-element.model';
import { FormElementSummary } from './form-element-summary.model';

export class FormElementFile extends FormElement {
  public constructor() {
    super();

    this.initialize();
  }

  public initialize = (): void => {
    this.Value = null;
    this.WebContentTypeId = 0;
    this.ElementTypeId = 18;
    this.LabelText = 'Upload a File';
  };

  public WebContentTypeId: number;
}
